module.exports = __webpack_public_path__ + "static/media/live_event1.52c80fd6.jpeg";